export const EnvironmentVariable = {
  localEnvConfig: {
    baseAPIURL: "REACT_APP_API_BASE_URL",
    accessToken: "REACT_APP_API_ACCESS_TOKEN",
    refreshToken: "REACT_APP_API_REFRESH_TOKEN",
  },
  idamConfig: {
    appURL: "REACT_APP_DOMAIN_URL",
    idamAPIURL: "REACT_APP_IDAM_API_URL",
    getAccessTokenURL: "REACT_APP_IDAM_GET_ACCESS_TOKEN_URL",
    loginURL: "REACT_APP_IDAM_URL",
    clientId: "REACT_APP_IDAM_CLIENT_ID",
    responseType: "code",
    scope: "REACT_APP_IDAM_SCOPE",
  },
  featureToggle: {
    hideMacroTool: "REACT_APP_FEATURE_HIDE_MICRO_TOOL",
  },
};
